import React, { useCallback, useState } from 'react';
import ToolTipCardSwipe from '../ToolTipSwipe/ToolTipSwipeCard'
import FlipPager from './FlipPager';
import { useT } from '../../i18n/LanguageProvider';

interface Props {
	pages: (() => JSX.Element)[];
	/** hide the "tap or swipe to flip" hint (single-page cards have nothing to flip) */
	hideHint?: boolean;
}

const CardViewerMobile: React.FC<Props> = ({ pages, hideHint }) => {
	const { t } = useT();
	const [showTooltip, setShowTooltip] = useState(true);
	const hideTooltip = useCallback(() => {
		if (showTooltip) setShowTooltip(false);
	}, [showTooltip]);

	return (
		<>
			<FlipPager pages={pages} hideTooltip={hideTooltip} />
			{showTooltip && !hideHint && <ToolTipCardSwipe text={t('viewcard.tapOrSwipeToFlip')} />}
		</>
	);
};

export default React.memo(CardViewerMobile);
